export default __webpack_public_path__ + "static/media/cloth_13.ac95557c.jpg";